const globalMixin = {
	data() {
		return {
			contentMinHeight: 0,
			contentPaddingBottom: 0,
			maskMinHeight: 0,
			showOpenOtherBroswer: false,
			useMarketLink: false,
			marketLinks: {
				"Android": {
					"market": "market://details?id=com.superchinese",
					"app": "superchinese://index",
				},
				"H5": {
					"market": "market://details?id=com.superchinese",
					"app": "superchinese://index",
				},
				"IOS": {
					"market": "https://apps.apple.com/cn/app/id1462500984",
					"app": "superchinese://index",
				},
			},
			info: {
				nickname: null,
				avatar: null,
				year: null,
				month: null,
				day: null,
				week: null,
				link: null,
				invite_code: null,
			}
		}
	},
	mounted() {
		this.contentPaddingBottom = this.$refs.bottom.offsetHeight
		this.contentMinHeight = window.screen.height - this.$refs.content.offsetTop - this.contentPaddingBottom
		this.maskMinHeight = window.innerHeight
	},
	methods: {
		openApp(call) {
			call()
			if (this.$common.inWechat) {
				return this.openOtherBroswer()
			}
			let links = this.marketLinks[this.$common.os]
			window.location.href = links.market
		},
		loadInfo(call) {
			this.$fetch(this.$common.apis.info).then(res => {
				this.info = res.data
				call()
			})
		},
		reportClick() {
			return this.$fetch(this.$common.apis.click).then(res => {
				this.info = res.data
			})
		},
		openOtherBroswer() {
			this.showOpenOtherBroswer = true
		},
		openinstall(call) {
			try {
				var that = this
				const s = document.createElement('script');
				s.type = 'text/javascript';
				s.src = '//web.cdn.openinstall.io/openinstall.js';
				s.addEventListener('load', () => {
					var data = OpenInstall.parseUrlParams();
					data.open_at = Number.parseInt(new Date().getTime()/1e3);
					new OpenInstall({
						appKey: "ujjzkx",
						onready: function () {
							var m = this, button = document.getElementById("openInstallButton");
							m.schemeWakeup();
							button.onclick = function () {
								if (that.useMarketLink) {
									return that.openApp(call)
								}
								call()
								console.log('m.wakeupOrInstall')
								m.wakeupOrInstall();
								that.reportClick();
								return false
							}
						}
					}, data);
				}, false)
				document.head.appendChild(s);
			} catch (err) {
				console.log(err)
			}
		},
		openOtherBroswer() {
			this.showOpenOtherBroswer = true
		},
	},
}
export default globalMixin